module.exports = __webpack_public_path__ + "static/media/short-hit.9ed69c39.png";